import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const EbanxPayment = () => {
  return <CommonProcess />;
};

export default EbanxPayment;
